import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LoginSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard/discover"); // Change this route to your actual dashboard path
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="flex items-center justify-center h-screen"
      style={{ background: "rgb(30, 37, 45)" }}
    >
      <div className="text-center">
        <img
          src="../images/t-icon.png"
          alt=""
          className="w-full object-cover"
        />
      </div>
    </div>
  );
};

export default LoginSuccess;
